// src/component/MiniTiptapEditor.tsx
import React, { useEffect } from "react";
import { EditorContent, useEditor } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import Bold from "@tiptap/extension-bold";
import Italic from "@tiptap/extension-italic";
import Underline from "@tiptap/extension-underline";
import Placeholder from "@tiptap/extension-placeholder";

import "../assets/css/component/TiptapEditor.css";

type Props = {
	content?: string;
	onChange?: (html: string) => void;
};

const MiniTiptapEditor: React.FC<Props> = ({
											   content = "",
											   onChange,
										   }) => {
	const editor = useEditor({
		extensions: [
			StarterKit,
			Bold,
			Italic,
			Underline,
			Placeholder.configure({
				placeholder: "댓글을 입력하세요...",
			}),
		],
		content,
		onUpdate: ({ editor }) => {
			onChange?.(editor.getHTML());
		},
	});

	// ✅ 부모에서 content 변경 시 에디터 동기화
	useEffect(() => {
		if (editor && content !== editor.getHTML()) {
			editor.commands.setContent(content, {
				emitUpdate: false,
			});
		}
	}, [content, editor]);

	if (!editor) return null;

	return (
		<div className="tiptap-wrapper mini">
			{/* ===== 경량 툴바 ===== */}
			<div className="tiptap-toolbar mini">
				<button
					type="button"
					onClick={() => editor.chain().focus().toggleBold().run()}
					className={editor.isActive("bold") ? "active" : ""}
				>
					B
				</button>
				<button
					type="button"
					onClick={() => editor.chain().focus().toggleItalic().run()}
					className={editor.isActive("italic") ? "active" : ""}
				>
					I
				</button>
				<button
					type="button"
					onClick={() =>
						editor.chain().focus().toggleUnderline().run()
					}
					className={editor.isActive("underline") ? "active" : ""}
				>
					U
				</button>
			</div>

			{/* ===== 에디터 ===== */}
			<div
				className="tiptap-editor mini"
				onClick={(e) => {
					/**
					 * 에디터 "빈 영역" 클릭 시
					 * → 커서를 마지막 줄로 이동
					 * (텍스트 클릭 / 드래그는 방해하지 않음)
					 */
					if (
						e.target instanceof HTMLElement &&
						e.target.classList.contains("tiptap-editor")
					) {
						editor.commands.focus("end");
					}
				}}
			>
				<EditorContent editor={editor} />
			</div>
		</div>
	);
};

export default MiniTiptapEditor;
